import { Star, ExternalLink, Award, Crown } from "lucide-react";
import { GMB_URL, BRAND } from "../mock";
import { openExternal } from "../lib/openExternal";

function GoogleG({ className = "w-5 h-5" }) {
  return (
    <svg viewBox="0 0 48 48" className={className} xmlns="http://www.w3.org/2000/svg">
      <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303a12 12 0 0 1-4.087 5.571l.003-.002 6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z"/>
      <path fill="#FF3D00" d="M6.306 14.691l6.571 4.819A11.99 11.99 0 0 1 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z"/>
      <path fill="#4CAF50" d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238A11.91 11.91 0 0 1 24 36a12 12 0 0 1-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z"/>
      <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303a12.04 12.04 0 0 1-4.087 5.571l6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z"/>
    </svg>
  );
}

export default function SocialProof() {
  const cards = [
    {
      icon: GoogleG,
      stat: `${BRAND.rating.count}+`,
      label: "Verified Google Reviews",
      sub: "Most-reviewed ceramic shop in the GTA",
      href: GMB_URL,
      external: true,
    },
    {
      icon: Award,
      stat: "1,500+",
      label: "Cars Coated Since 2018",
      sub: "Mississauga · Toronto · GTA-wide",
    },
    {
      icon: Crown,
      stat: "5",
      label: "Stars Across the Board",
      sub: "Every coating documented and warrantied",
      stars: true,
    },
  ];

  return (
    <section className="relative py-16 md:py-20 bg-gradient-to-b from-[#0c0119] to-[#120127] border-y border-jester/20">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-3 gap-5">
          {cards.map((c, i) => {
            const Icon = c.icon;
            const Comp = c.href ? "a" : "div";
            const linkProps = c.href
              ? { href: c.href, target: "_blank", rel: "noopener noreferrer" }
              : {};
            return (
              <Comp
                key={i}
                {...linkProps}
                className="google-card rounded-2xl p-7 flex items-center gap-5 group"
              >
                <div className="w-14 h-14 rounded-xl bg-jester-purple/20 flex items-center justify-center flex-shrink-0">
                  <Icon className="w-7 h-7 text-acid" />
                </div>
                <div className="flex-1 min-w-0">
                  {c.stars ? (
                    <div className="flex items-center gap-1 mb-1">
                      {[...Array(5)].map((_, k) => (
                        <Star
                          key={k}
                          className="w-5 h-5"
                          style={{ color: "#FDC814", fill: "#FDC814" }}
                        />
                      ))}
                    </div>
                  ) : (
                    <div className="font-stencil text-3xl text-white">
                      {c.stat}
                    </div>
                  )}
                  <div className="text-sm text-white/85 font-semibold mt-0.5">
                    {c.label}
                  </div>
                  <div className="text-xs text-white/50 mt-0.5 truncate">
                    {c.sub}
                  </div>
                </div>
                {c.external && (
                  <ExternalLink className="w-4 h-4 text-white/30 group-hover:text-acid transition-colors flex-shrink-0" />
                )}
              </Comp>
            );
          })}
        </div>
      </div>
    </section>
  );
}
